// Handles post-deactivation — reloads the deactivating tab, shows reload prompt for all others
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    const deactivatedHere = sessionStorage.getItem('superuser_deactivated_here')

    this.clearSessionFlags()

    if (deactivatedHere) {
      window.location.reload()
    } else {
      this.dialogTarget.showModal()
    }
  }

  clearSessionFlags() {
    sessionStorage.removeItem('superuser_deactivated_here')
    sessionStorage.removeItem('superuser_activated_here')
  }

  reload() {
    window.location.reload()
  }
}
